import CreateCourse from './containers/CreateCourse';
import ArchivedCourse from './containers/ArchivedCourse';
import AdvanceSettingMilestone from './containers/AdvanceSettingMilestone';
import CourseDetail from './containers/CourseDetail';
import MilestoneDetails from './containers/MilestoneDetails';
import CourseTemplate from './containers/CourseTemplate';

import { combineReducers } from 'redux';

import courseReducer from './reducers/courseReducer';


const reducers = combineReducers({
    courseData: courseReducer
});

const components = {CreateCourse ,AdvanceSettingMilestone, CourseDetail  , MilestoneDetails,CourseTemplate,ArchivedCourse};

export { components, reducers };